import { TableCell, TableRow } from "@mui/material";
import moment from "moment";
import React from "react";

import StatusDropdown from "../../../../../common/StatusDropdown";
import { showNotification } from "../../../../../constants";
import { useAuth } from "../../../../../hooks";
import { Toast } from "../../../../../common/alert";
import { getSingleUser } from "../../../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import {
  updateContributorInviteStatus,
} from "../../hooks/GAUsersHooks";
import {
  updateContributor,
} from "../../../../../modules/Contributors/hooks/ContributorsHook";

const ContributorInvitesTableRow = ({
  row,
  numberType,
  onStatusChange,
  columnWidths,
}) => {
  const { currentUser } = useAuth();

  const handleUpdateStatus = async (newStatus) => {
    try {
      // Get user data to update organizations array
      let userResponse = await getSingleUser(row?.userId);

      if (
        userResponse?.data() &&
        userResponse?.data()?.organizations &&
        userResponse?.data()?.organizations?.includes(row?.organization)
      ) {
        // User already has org in their list
        if (newStatus !== "accepted") {
          // Remove org from user's organizations array
          let orgTemp = [...(userResponse?.data()?.organizations ?? [])];
          const updatedOrganization = orgTemp.filter(
            (id) => id !== row?.organization
          );
          let dataTemp = {
            organizations: updatedOrganization,
            updatedBy: currentUser.id,
            updatedAt: new Date(),
          };
          await updateContributor(row?.userId, dataTemp);
        }
      } else {
        // User doesn't have org in their list
        if (newStatus === "accepted") {
          let dataTemp = {
            organizations: [
              ...(userResponse?.data()?.organizations ?? []),
              row?.organization,
            ],
            updatedBy: currentUser.id,
            updatedAt: new Date(),
          };
          await updateContributor(row?.userId, dataTemp);
        }
      }

      // Update the contributor invite status
      let statusUpdateData = {
        updatedAt: new Date(),
        status: newStatus,
        updatedBy: currentUser?.id,
      };
      await updateContributorInviteStatus(row.id, statusUpdateData);

      showNotification("Contributor status updated successfully.");

      // Refresh the invites list
      if (onStatusChange) {
        await onStatusChange();
      }
    } catch (error) {
      Toast("error", error.message);
      console.log("Error updating contributor invite status:", error.message);
    }
  };

  const dropdownOptions = ["accepted", "automatic", "inactive", "requested"];

  return (
    <TableRow
      hover
      tabIndex={-1}
      key={row.id}
      sx={{
        cursor: "default",
        height: 30,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        padding="none"
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.organizationName || 250,
          minWidth: columnWidths?.organizationName || 250,
          maxWidth: columnWidths?.organizationName || 250,
        }}
      >
        {row.organizationName || "Loading..."}
      </TableCell>
      <TableCell
        padding="none"
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 170,
          maxWidth: columnWidths?.createdAt || 170,
        }}
      >
        {row.createdAt &&
          moment.unix(row.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          width: columnWidths?.status || 140,
          minWidth: columnWidths?.status || 140,
          maxWidth: columnWidths?.status || 140,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <StatusDropdown
          options={dropdownOptions}
          currentValue={row?.status}
          onChange={handleUpdateStatus}
        />
      </TableCell>
      <TableCell
        padding="none"
        align="left"
        style={{
          ...tableCellStyles,
          width: columnWidths?.updatedAt || 170,
          minWidth: columnWidths?.updatedAt || 170,
          maxWidth: columnWidths?.updatedAt || 170,
        }}
      >
        {row.updatedAt &&
          moment.unix(row.updatedAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
    </TableRow>
  );
};

export default ContributorInvitesTableRow;

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  height: 30,
  paddingLeft: 10,
};
